export default "__VITE_ASSET__m9fFw3YanAGyFsEpm9ZGEw__"